import React, { Component } from 'react'
import '../../styles/css/SideMenu.css'
import { base } from '../../base';
import '../../styles/css/AdminMain.css'
import logoImage from '../../styles/images/sqwad-hand.png'
import { Link } from 'react-router-dom'

class SideMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
          sessionList: []
        };
    }

    componentWillMount() {
      this.sessions = base.syncState(`sessionList`, {
        context: this,
        state: 'sessionList',
        asArray: true
      });
    }

    componentWillUnmount() {
    }

    render() {
        return (
          <div className="admin-sidebar">
            <div className="logo">
              <Link to="/admin/home" className="simple-text logo-mini">
                <div className="logo-img"><img src={logoImage} alt=""/></div>
              </Link>
              <Link to="/admin/home" className="simple-text logo-normal">SQWAD</Link>
            </div>
            <div className="nav-container">
              <ul className="nav">
                <li className="">
                  <Link to="/admin/home">
                    <span className="fa fa-home"></span>
                    <span className="text">Home</span>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/setupvoting">
                    <span className="fa fa-check-circle"></span>
                    <span className="text">Voting</span>
                  </Link>
                </li>
                {/*
                <li>
                  <Link to="/admin/setupcurrentsession">
                    <span className="fa fa-hourglass"></span>
                    <span className="text">Live Session</span>
                  </Link>
                </li>
                {
                  this.state.sessionList.map(function(item, i){
                    if(item.sideSession){
                      return (
                        <li>
                          <Link to={`/admin/session/${item.id}`}>
                            <span className="fa fa-bullhorn"></span>
                            <span className="text">Session {item.id}</span>
                          </Link>
                        </li>
                      )
                    }
                  })
                }
                <li>
                  <Link to="/admin/setupsessions">
                    <span className="fa fa-bullhorn"></span>
                    <span className="text">Create Sessions</span>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/setupquestions">
                    <span className="fa fa-question-circle"></span>
                    <span className="text">Questions</span>
                  </Link>
                </li>
                */}
                <li>
                  <Link to="/logout">
                    <span className="fa fa-sign-out"></span>
                    <span className="text">Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

        );
    }
}

export default SideMenu


// <div style={{float:'left'}}>
// <div style={{margin:'auto'}}>
//   <a href="/admin/setUpTrivia">Trivia</a>
// </div>
// <div style={{margin:'auto'}}>
//   <a href="/admin">Scratchers</a>
// </div>
// </div>



// WEBPACK FOOTER //
// ./src/components/admin/SideMenu.js